import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { respondToAppointmentRequest } from '@/services/MeetingController';

export function AppointmentRespond() {
	const [searchParams] = useSearchParams();
	const [success, setSuccess] = useState(null);
	const token = searchParams.get('token');
	const answer = searchParams.get('answer');

	const [status, setStatus] = useState(() => {
		if (!token || !answer) {
			return 'Invalid link provided';
		}
		return 'Verifying token...';
	});

	console.log('token', token);
	console.log('answer', answer);

	const respond = async () => {
		try {
			const res = await respondToAppointmentRequest(answer, token);
			if (res.success) {
				setStatus(`Appointment ${res.action}ed successfully!`);
				setSuccess(true);
			} else {
				setStatus('Invalid or expired token.');
			}
		} catch (error) {
			console.log('respond err:', error);
			setStatus('Something went wrong.');
		}
	};
	useEffect(() => {
		respond();
	}, []);

	return (
		<div className='flex flex-col items-center gap-y-5'>
			<div className='p-4'>{status}</div>
			{success && <div className='p-4'>You can safely close this page.</div>}
		</div>
	);
}
